<template>
  <div id="app">
    <router-view  />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
 
    };
  },
  // computed: {
  //   // 存储到store状态管理中
  //   ...mapState({
  //     headerTitle: state => state.$vux.headerTitle,
  //   })
  // },
 
};
</script>
<style>
body {
    margin: 0;
    min-height: 100vh;
    position: relative;
    font-family: PingFangSC;
}
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50; */
  margin: 0;
}

/* #nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
} */
</style>
